<script>
    import { required } from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import Swal from "sweetalert2";
    import Notification from "@/services/Notification";
    import Customers from "@/services/Customers";
    import Content from '@/services/Content';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js';
    import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';
    import moment from "moment";
    import General from '@/services/General'
 
    export default {
        components:{
            flatPickr,
            validationMessages
        },
        validations: {
            notifData:{
                message:{
                    required
                },
//              group:{
//                required
//              }
            },
        },
        data() {
            return {
                notification_languages: JSON.parse(process.env.VUE_APP_NOTIFICATION_LANG),
                csrf_token: localStorage.getItem('csrf_token'),
                showModal: false,
                showSchedule: false,
                tryingToSubmit: false,
                submitted: false,
                notifTypes: false,
                datetimeconfig: {
                    enableTime: true,
                    time_24hr: true,
                    dateFormat: "Y-m-d H:i",
                    minDate: "today",
                    minuteIncrement: 1,
                    defaultDate: new Date(),
                    plugins: [new ConfirmDatePlugin({})]
                },
                notifData: {
                    type: '',
                    message: '',
                    title: '',
                    recipient: 'ALL',
                    schedule_time: '',
                    language: '',
                    group: '',
                    priority:'low'
                },
                deepLinkingAction:'',
                // dynamic second-level support
                showSecondLevel: false,
                second_level_key: '',
                second_level_title: '',
                secondLevelOptions: [],
                selectedSecondLevel: '',
                deepLinkingFullScreen:'Yes',
                deep_link: [],
                groups: [],
                deepLinkActions: [],
                methodOption: [],
                deepLinkFullScreen:[
                    { "key": true, "value": "Yes" },
//                    { "key": false, "value": "No" },
                ],
                dateconfig: {
                  enableTime: false,
                  dateFormat: "Y-m-d",
                  minDate: new Date(),
                },
                timeconfig: {
                  enableTime: true,
                  noCalendar: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "H:i",
                  allowInput: true,
                },
                date: '',
                time: '',
            };
        },
        created() {
            this.getNotificationTypes()
            this.getGroups()
            this.getDeeplinkCampaignMethods()
        },
        methods: {
            openDatePicker() {
              this.$refs.datePicker.$el.click();
            },
            openTimePicker() {
              this.$refs.timePicker.$el.click();
            },
            refreshNotificatinData() { 
                this.$emit('refreshScreen') //event from parent
            },
           getDeeplinkCampaignMethods(){
                General.getDeeplinkCampaignMethods()
                    .then((response) => {
                        const data = response.data.data ? response.data.data : [];
                        this.methodOption = data;
                        this.deepLinkActions = data.map(item => ({
                            action: item.method,
                            name: item.description
                        }));
                    })
                    .catch(() => {
                        this.methodOption = []
                        this.deepLinkActions = []
                    })
            },

            getDeeplinkSecondLevel(second_level){
                if(!second_level){
                    this.secondLevelOptions = []
                    this.showSecondLevel = false
                    this.selectedSecondLevel = ''
                    return
                }
                General.getDeeplinkSecondLevelOptions(second_level)
                    .then((response) => {
                        this.secondLevelOptions = response.data.data ? response.data.data : []
                        this.showSecondLevel = this.secondLevelOptions.length > 0
                    })
                    .catch(() => {
                        this.secondLevelOptions = []
                        this.showSecondLevel = false
                    })
            },
            addNotification(){
                //submit
                this.tryingToSubmit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToSubmit = false;
                    return;
                } else {

                    if (this.date && this.time) {
                      this.notifData.schedule_time = `${this.date} ${this.time}:00`;
                    }else{
                      this.notifData.schedule_time = ''
                    }

                    let formData = new FormData();
//                    formData.append('type', this.notifData.type);
                    formData.append('type', 'promotion');
                    formData.append('message', this.notifData.message);
                    formData.append('title', this.notifData.title);
                    formData.append('recipient', this.notifData.recipient);
                    formData.append('schedule_time', this.notifData.schedule_time);
                    formData.append('language', this.notifData.language);
                    formData.append('csrf_token', this.csrf_token);
                    formData.append('deep_link[action]', this.deepLinkingAction);
                    formData.append('deep_link[fullscreen]', this.deepLinkingFullScreen);
                    if(this.selectedSecondLevel && this.second_level_key){
                        formData.append(`deep_link[${this.second_level_key}]`, this.selectedSecondLevel);
                    }

                    if(this.notifData.recipient == 'GROUP'){
                        formData.append('group_id', this.notifData.group);
                     }

                    formData.append('processing', 'api');
                    formData.append('priority', this.notifData.priority);

                    //Confirmation Popup with Countdown
                    let countdown = 15;
                    let timer;
                    let userInteracted = false;

                    Swal.fire({
                        title: "Send New Push Notification",
                        html: `Sending in <b>${countdown}</b> seconds...`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#34c38f",
                        cancelButtonColor: "#f46a6a",
                        confirmButtonText: "Send",
                        allowOutsideClick: false,
                        didOpen: () => {
                            const b = Swal.getHtmlContainer().querySelector("b");

                            timer = setInterval(() => {
                                countdown--;
                                b.textContent = countdown;

                                if (countdown <= 0) {
                                    clearInterval(timer);
                                    if (!userInteracted) {
                                        Swal.clickConfirm(); // act as if "Send" was clicked
                                    }
                                }
                            }, 1000);
                        },
                        willClose: () => {
                            clearInterval(timer); // clean up when modal closes
                        }
                    }).then((result) => {
                        userInteracted = true; // prevent auto-trigger if already clicked
                        if (result.isConfirmed) {
                            Notification.create(formData)
                              .then((response) => {
                                  const res = response.data.success ? response.data.success : false;
                                  const error = response.data.error ? response.data.error : '';
                                  if (res) {
                                      Swal.fire("OK!", "Bulk Push Notification Created !", "success")
                                      this.refreshNotificatinData();
                                      this.closeModal();
                                  } else {
                                      Swal.fire("Fail!", error, "warning")
                                  }
                              })
                              .catch(error => {
                                  this.tryingToSubmit = false;
                                  const resData = error.response.data.error ? error.response.data.error : 'Failed';
                                  const errorMsg = Array.isArray(resData) ? resData[0] : resData;
                                  Swal.fire("Fail!", errorMsg, "warning")
                              }).finally(() => {
                                  this.tryingToSubmit = false;
                              })
                        } else {
                            this.tryingToSubmit = false;
                        }
                    });

                }
            },

            getNotificationTypes() {
                this.notifTypes =  [];
                var filterString = 'system=N';
                Notification.getNotificationTypes(filterString)
                .then((response) => {
                    this.notifTypes = response.data.data
                    if(this.notifTypes.length > 0){
                        this.notifData.type = this.notifTypes[0].type_code
                    }
                })
            },

             getGroups() {
                this.groups =[];
                Customers.getCustomersGroups()
                .then((response) => {
                    this.groups = response.data.data
                    if(this.groups.length > 0){
                    //   this.notifData.group = this.groups[0].group_id
                   }
                })
            },

            async getNews() {
                try {
                    await Content.getNews(10)
                        .then((response) => {
                        this.news = response.data.news;
                        if(this.news.length > 0){
                            this.news.forEach((newsItem, index) => {
                                this.deepLinkActionsNews.push({ "articleId": newsItem.source_id, "name": newsItem.title });
                            });
                        }
                    }).catch(error => {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg("Can not get news")
                    }).finally(() => {
                        this.showLoader = false;
                    })

                } catch (error) {
                    this.showLoader = false;
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg("Can not get news")
                }
            },

            async getVideos() {
                try {
                    await Content.getVideos(10)
                        .then((response) => {
                            this.videos = response.data.videos;
                            if(this.videos.length > 0){
                            this.videos.forEach((videoItem, index) => {
                                this.deepLinkActionsVideos.push({ "videoId": videoItem.id, "name": videoItem.title });
                            });
                        }
                    }).catch(error => {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg("Can not get videos")
                    }).finally(() => {
                        this.showLoader = false;
                    })

                } catch (error) {
                    this.showLoader = false;
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg("Can not get videos")
                }
            },

            closeModal() {
                this.showModal = false;
                this.notifData.type = '';
                this.notifData.message = '';
                this.notifData.title = '';
                this.notifData.recipient = 'ALL';
                this.notifData.schedule_time = '';
                this.date = '';
                this.time = '';
                this.notifData.language = '';
                this.tryingToSubmit = false;
                this.showSchedule = false;
                this.notifData.group_id = '';
                this.notifData.priority = 'low';
            },

            scheduleNotification(){
                this.showSchedule = !this.showSchedule

                if(this.schedule_time){
                    this.schedule_time = moment().add(1, 'hours').format("YYYY-MM-DD HH:mm");
                }else{
                    this.schedule_time = '';
                }
            },

            resetProps(){
                this.notifData.type = '';
                this.notifData.message = '';
                this.notifData.title = '';
                this.notifData.recipient = 'ALL';
                this.notifData.schedule_time = '';
                this.date = '';
                this.time = '';
                this.notifData.language = '';
                this.tryingToSubmit = false;
                this.showSchedule = false;
                this.deepLinkingAction = '';
                this.selectedSecondLevel = '';
                this.secondLevelOptions = [];
                this.showSecondLevel = false;
                this.deepLinkingFullScreen = '';
                this.notifData.group_id = '';
                this.notifData.priority = 'low';
                this.submitted  = false
            },

           onChangeScreen(){
                this.showSecondLevel = false
                this.secondLevelOptions = []
                this.selectedSecondLevel = ''
                // find selected method metadata
                const selected = this.methodOption.find(m => m.method === this.deepLinkingAction)
                this.second_level_key = selected && selected.second_level ? selected.second_level : ''
                this.second_level_title = selected && selected.second_level_description ? selected.second_level_description : ''
                if(this.second_level_key){
                    this.getDeeplinkSecondLevel(this.second_level_key)
                }
            }
        },
    };
</script>

<template>
    <b-modal
        @hidden="resetProps"
        id="add_new_push_notification"
        size="lg"
        v-model="showModal"
        title="Bulk Push Notification"
        title-class="text-black font-18"
        body-class="p-3"
    >

      <template v-slot:modal-header>
        <div class="w-100">
          <h5 class="modal-title mb-0">New Push Notification</h5>
          <p class="text-muted mb-0 mt-2">Configure and send push notifications to your users</p>
        </div>
        <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
      </template>

    <form @submit.prevent="addNotification ">
        <div class="card mb-3">
          <div class="card-body py-2">

            <div class="mb-3">
              <label class="control-label form-label">Recipients</label>
              <select v-model="notifData.recipient" class="form-control form-select" type="select">
                <option value="ALL">All Users</option>
                <option value="IOS">IOS Users</option>
                <option value="ANDROID">Android Users</option>
                <option value="GROUP" v-if="groups.length > 0">Group</option>
              </select>
            </div>

            <div class="mb-3 ps-3 border-start" v-if="notifData.recipient == 'GROUP'"  >
              <label label="Group" class="control-label form-label">User Segment</label>
              <select v-model="notifData.group"
                      class="form-control form-select"
                      type="select"
                      :class="{
                                'is-invalid': submitted && $v.notifData.group.$error,
                              }"
              >
                <option v-for="group in groups" :key="group.group_id" :value="group.group_id">
                  {{ group.name }}
                </option>
              </select>
              <validationMessages v-if="submitted" :fieldName="'Group'" :validationName="$v.notifData.group"></validationMessages>
            </div>

            <div class="mb-3">
              <label class="control-label form-label">Notification Title</label>
              <b-form-input v-model="notifData.title" :maxlength="40"></b-form-input>
              <p class="font-size-13 mt-1"><i class="uil-info-circle me-1"></i>Visible length: ~ 40–60 characters. Longer titles get truncated with "…"</p>
            </div>

            <b-form-group label="Message" label-for="formrow-message-input" class="mb-3">
              <b-form-textarea
                  v-model="notifData.message"
                  rows="3"
                  :maxlength="150"
                  placeholder="Enter notification message"
                  :class="{
                              'is-invalid': submitted && $v.notifData.message.$error,
                          }"
              >
              </b-form-textarea>
              <p class="font-size-13 mt-1"><i class="uil-info-circle me-1"></i>Visible length: ~ 100–150 characters</p>
              <validationMessages v-if="submitted" :fieldName="'Message'" :validationName="$v.notifData.message"></validationMessages>
            </b-form-group>

            <div class="mb-3">
              <label class="control-label form-label">Deeplink</label>
              <select v-model="deepLinkingAction" class="form-control form-select" type="select" @change="onChangeScreen">
                <option value="">Home screen</option>
                <option v-for="screen in deepLinkActions" :key="screen.action" :value="screen.action">
                  {{ screen.name }}
                </option>
              </select>
            </div>

            <div class="mb-3" v-if="showSecondLevel">
              <label class="control-label form-label">{{ second_level_title }}</label>
              <select v-model="selectedSecondLevel" class="form-control form-select" type="select">
                <option v-for="option in secondLevelOptions" :key="option.id" :value="option.id">
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div class="mb-3" v-if="notification_languages.length > 0">
              <label class="control-label form-label">Language</label>
              <select v-model="notifData.language" class="form-control form-select" name="type" type="select" >
                <option value="">All</option>
                <option v-for="lang in notification_languages" :key="lang" :value="lang">{{lang}}</option>
              </select>
            </div>

          </div>
        </div>

<!--                <div class="mb-3">
                    <label class="control-label form-label">Type: Promotion</label>
                    &lt;!&ndash;<select v-model="notifData.type" class="form-control form-select" type="select" >&ndash;&gt;
                        &lt;!&ndash;<option v-for="item in notifTypes" :key="item.type_code" :value="item.type_code">&ndash;&gt;
                            &lt;!&ndash;{{item.type_name }} &ndash;&gt;
                        &lt;!&ndash;</option>&ndash;&gt;
                    &lt;!&ndash;</select>&ndash;&gt;
                </div>-->

                <!--<div class="mb-5">-->
                    <!--<label class="control-label form-label">Full Screen</label>-->
                    <!--<select v-model="deepLinkingFullScreen" class="form-control form-select" type="select">-->
                        <!--<option></option>-->
                        <!--<option v-for="fs in deepLinkFullScreen" :key="fs.key" :value="fs.key">-->
                            <!--{{ fs.value }}-->
                        <!--</option>-->
                    <!--</select>-->
                <!--</div>-->


        <div class="card mb-3">
          <div class="card-body py-4">
            <b-form-checkbox-group>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <label class="form-check-label mb-1" for="showSchedule">Schedule Notification</label>
                  <p class="text-muted mb-0">Send notification at a specific date and time</p>
                </div>

                <div class="form-check form-switch form-switch-lg mb-0">
                  <input v-model="showSchedule"
                         type="checkbox"
                         class="form-check-input"
                         id="showSchedule"
                         @click="scheduleNotification()"
                  />
                </div>
              </div>
            </b-form-checkbox-group>

<!--            <b-form-group v-if="showSchedule" class="my-3 ps-3 border-start">
              <label class="form-label mb-3">Set date/time</label>
              <flat-pickr
                  v-model="notifData.schedule_time"
                  :config="datetimeconfig"
                  class="form-control"
              />
            </b-form-group>-->

            <div class="row mt-2 ps-3 border-start" v-if="showSchedule">
              <div class="col-md-6">
                <label class="mb-1">
                  <i class="uil uil-calendar-alt me-1"></i>Date *
                </label>
                <div class="position-relative">
                  <flat-pickr
                      ref="datePicker"
                      v-model="date"
                      :config="dateconfig"
                      class="form-control pe-4"
                      name="date"
                  />
                  <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                     style="cursor: pointer; pointer-events: all;"
                     @click="openDatePicker"></i>
                </div>
              </div>

              <div class="col-md-6">
                <label class="mb-1">
                  <i class="uil uil-clock me-1"></i>Time *
                </label>
                <div class="position-relative">
                  <flat-pickr
                      ref="timePicker"
                      v-model="time"
                      :config="timeconfig"
                      class="form-control pe-4"
                      name="time"
                  />
                  <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                     style="cursor: pointer; pointer-events: all;"
                     @click="openTimePicker"></i>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="card mb-3">
          <div class="card-body py-2">
            <label class="form-label mb-3">Priority Processing</label>

              <div class="mb-2 border p-3">
                <label class="d-block">
                  <input type="radio" id="priority-low" class="me-2" name="priority" value="low" v-model="notifData.priority">
                  <strong>Priority Processing</strong><br>
                  <span class="text-muted ms-4">Takes approximately 60 minutes to send notification to all users</span>
                </label>
              </div>

              <div class="mb-2 border p-3">
                <label class="d-block ">
                  <input type="radio" id="priority-high" class="me-2" name="priority" value="high" v-model="notifData.priority">
                  <strong>High Priority Processing</strong><br>
                  <span class="text-muted ms-4">Takes approximately 30 minutes to send notification to all users</span>
                </label>
              </div>

          </div>
        </div>

        <input type="hidden" name="csrf_token" v-model="csrf_token">
      </form>

      <template v-slot:modal-footer>
          <b-button variant="light" @click="closeModal">Cancel</b-button>
          <b-button variant="primary" @click="addNotification" :disabled="tryingToSubmit">
              <b-spinner v-show="tryingToSubmit" small></b-spinner>
              Save & Send</b-button>
      </template>

    </b-modal>
 
</template>
